/* tslint:disable */
/*
 * Autogenerated by @creditkarma/thrift-typescript v2.0.14
 * DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
*/
import * as thrift from "thrift";
import * as GenericExceptions from "./../../thrift/protocol/common/exceptions";
import * as PHeader from "./../../thrift/protocol/common/models";
import * as PushContacts from "./../../thrift/protocol/contactssync/messages";
import * as FetchContacts from "./../../thrift/protocol/contactssync/messages";
import * as FixThisCard from "./../../thrift/protocol/contactssync/messages";
import * as ContactDetails from "./../../thrift/protocol/contactssync/messages";
import * as SuggestMerges from "./../../thrift/protocol/contactssync/messages";
import * as EnsureSynced from "./../../thrift/protocol/contactssync/messages";
import * as SelfContact from "./../../thrift/protocol/contactssync/messages";
import * as FetchOriginalContacts from "./../../thrift/protocol/contactssync/messages";
import * as UndoMerge from "./../../thrift/protocol/contactssync/messages";
import * as ContactsSinceBackup from "./../../thrift/protocol/contactssync/messages";
export namespace TContactsSyncService {
    export interface IPushContactsArgsArgs {
        header: PHeader.TAuthHeader;
        request: PushContacts.TPushContactsRequest;
    }
    export class PushContactsArgs {
        public header: PHeader.TAuthHeader;
        public request: PushContacts.TPushContactsRequest;
        constructor(args: IPushContactsArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("PushContactsArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): PushContactsArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_1: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_1;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_2: PushContacts.TPushContactsRequest = PushContacts.TPushContactsRequest.read(input);
                            _args.request = value_2;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new PushContactsArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read PushContactsArgs from input");
            }
        }
    }
    export interface IFetchContactsArgsArgs {
        header: PHeader.TAuthHeader;
        request: FetchContacts.TFetchContactsRequest;
    }
    export class FetchContactsArgs {
        public header: PHeader.TAuthHeader;
        public request: FetchContacts.TFetchContactsRequest;
        constructor(args: IFetchContactsArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchContactsArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchContactsArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_3: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_3;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_4: FetchContacts.TFetchContactsRequest = FetchContacts.TFetchContactsRequest.read(input);
                            _args.request = value_4;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new FetchContactsArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read FetchContactsArgs from input");
            }
        }
    }
    export interface IFixThisCardArgsArgs {
        header: PHeader.TAuthHeader;
        request: FixThisCard.TFixThisCardRequest;
    }
    export class FixThisCardArgs {
        public header: PHeader.TAuthHeader;
        public request: FixThisCard.TFixThisCardRequest;
        constructor(args: IFixThisCardArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FixThisCardArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FixThisCardArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_5: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_5;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_6: FixThisCard.TFixThisCardRequest = FixThisCard.TFixThisCardRequest.read(input);
                            _args.request = value_6;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new FixThisCardArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read FixThisCardArgs from input");
            }
        }
    }
    export interface IGetContactDetailsArgsArgs {
        header: PHeader.TAuthHeader;
        request: ContactDetails.TGetContactDetailsRequest;
    }
    export class GetContactDetailsArgs {
        public header: PHeader.TAuthHeader;
        public request: ContactDetails.TGetContactDetailsRequest;
        constructor(args: IGetContactDetailsArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("GetContactDetailsArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): GetContactDetailsArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_7: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_7;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_8: ContactDetails.TGetContactDetailsRequest = ContactDetails.TGetContactDetailsRequest.read(input);
                            _args.request = value_8;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new GetContactDetailsArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read GetContactDetailsArgs from input");
            }
        }
    }
    export interface IGetAnatomyOfContactArgsArgs {
        header: PHeader.TAuthHeader;
        request: ContactDetails.TGetAnatomyOfContactRequest;
    }
    export class GetAnatomyOfContactArgs {
        public header: PHeader.TAuthHeader;
        public request: ContactDetails.TGetAnatomyOfContactRequest;
        constructor(args: IGetAnatomyOfContactArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("GetAnatomyOfContactArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): GetAnatomyOfContactArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_9: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_9;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_10: ContactDetails.TGetAnatomyOfContactRequest = ContactDetails.TGetAnatomyOfContactRequest.read(input);
                            _args.request = value_10;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new GetAnatomyOfContactArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read GetAnatomyOfContactArgs from input");
            }
        }
    }
    export interface IGetUndoableActionsForContactArgsArgs {
        header: PHeader.TAuthHeader;
        request: ContactDetails.TGetUndoableActionsForContactRequest;
    }
    export class GetUndoableActionsForContactArgs {
        public header: PHeader.TAuthHeader;
        public request: ContactDetails.TGetUndoableActionsForContactRequest;
        constructor(args: IGetUndoableActionsForContactArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("GetUndoableActionsForContactArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): GetUndoableActionsForContactArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_11: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_11;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_12: ContactDetails.TGetUndoableActionsForContactRequest = ContactDetails.TGetUndoableActionsForContactRequest.read(input);
                            _args.request = value_12;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new GetUndoableActionsForContactArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read GetUndoableActionsForContactArgs from input");
            }
        }
    }
    export interface IUpdateSuggestedMergesArgsArgs {
        header: PHeader.TAuthHeader;
        request: SuggestMerges.TUpdateSuggestedMergeRequest;
    }
    export class UpdateSuggestedMergesArgs {
        public header: PHeader.TAuthHeader;
        public request: SuggestMerges.TUpdateSuggestedMergeRequest;
        constructor(args: IUpdateSuggestedMergesArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UpdateSuggestedMergesArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UpdateSuggestedMergesArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_13: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_13;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_14: SuggestMerges.TUpdateSuggestedMergeRequest = SuggestMerges.TUpdateSuggestedMergeRequest.read(input);
                            _args.request = value_14;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new UpdateSuggestedMergesArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read UpdateSuggestedMergesArgs from input");
            }
        }
    }
    export interface IUpdateMultipleSuggestedMergesArgsArgs {
        header: PHeader.TAuthHeader;
        request: SuggestMerges.TUpdateSuggestedMergesRequest;
    }
    export class UpdateMultipleSuggestedMergesArgs {
        public header: PHeader.TAuthHeader;
        public request: SuggestMerges.TUpdateSuggestedMergesRequest;
        constructor(args: IUpdateMultipleSuggestedMergesArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UpdateMultipleSuggestedMergesArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UpdateMultipleSuggestedMergesArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_15: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_15;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_16: SuggestMerges.TUpdateSuggestedMergesRequest = SuggestMerges.TUpdateSuggestedMergesRequest.read(input);
                            _args.request = value_16;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new UpdateMultipleSuggestedMergesArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read UpdateMultipleSuggestedMergesArgs from input");
            }
        }
    }
    export interface IUndoSuggestedMergesArgsArgs {
        header: PHeader.TAuthHeader;
        request: SuggestMerges.TUndoSuggestedMergeRequest;
    }
    export class UndoSuggestedMergesArgs {
        public header: PHeader.TAuthHeader;
        public request: SuggestMerges.TUndoSuggestedMergeRequest;
        constructor(args: IUndoSuggestedMergesArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UndoSuggestedMergesArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UndoSuggestedMergesArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_17: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_17;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_18: SuggestMerges.TUndoSuggestedMergeRequest = SuggestMerges.TUndoSuggestedMergeRequest.read(input);
                            _args.request = value_18;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new UndoSuggestedMergesArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read UndoSuggestedMergesArgs from input");
            }
        }
    }
    export interface IExecuteManualMergeArgsArgs {
        header: PHeader.TAuthHeader;
        request: SuggestMerges.TUpdateSuggestedMergeRequest;
    }
    export class ExecuteManualMergeArgs {
        public header: PHeader.TAuthHeader;
        public request: SuggestMerges.TUpdateSuggestedMergeRequest;
        constructor(args: IExecuteManualMergeArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("ExecuteManualMergeArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): ExecuteManualMergeArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_19: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_19;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_20: SuggestMerges.TUpdateSuggestedMergeRequest = SuggestMerges.TUpdateSuggestedMergeRequest.read(input);
                            _args.request = value_20;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new ExecuteManualMergeArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read ExecuteManualMergeArgs from input");
            }
        }
    }
    export interface IExecuteUndoMergeArgsArgs {
        header: PHeader.TAuthHeader;
        request: UndoMerge.TUndoMergeRequest;
    }
    export class ExecuteUndoMergeArgs {
        public header: PHeader.TAuthHeader;
        public request: UndoMerge.TUndoMergeRequest;
        constructor(args: IExecuteUndoMergeArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("ExecuteUndoMergeArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): ExecuteUndoMergeArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_21: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_21;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_22: UndoMerge.TUndoMergeRequest = UndoMerge.TUndoMergeRequest.read(input);
                            _args.request = value_22;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new ExecuteUndoMergeArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read ExecuteUndoMergeArgs from input");
            }
        }
    }
    export interface IEnsureSyncedArgsArgs {
        header: PHeader.TAuthHeader;
        request: EnsureSynced.TEnsureSyncedRequest;
    }
    export class EnsureSyncedArgs {
        public header: PHeader.TAuthHeader;
        public request: EnsureSynced.TEnsureSyncedRequest;
        constructor(args: IEnsureSyncedArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("EnsureSyncedArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): EnsureSyncedArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_23: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_23;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_24: EnsureSynced.TEnsureSyncedRequest = EnsureSynced.TEnsureSyncedRequest.read(input);
                            _args.request = value_24;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new EnsureSyncedArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read EnsureSyncedArgs from input");
            }
        }
    }
    export interface IFetchAdditionalSelfContactInfoArgsArgs {
        header: PHeader.TAuthHeader;
        request: SelfContact.TFetchAdditionalSelfContactInfoRequest;
    }
    export class FetchAdditionalSelfContactInfoArgs {
        public header: PHeader.TAuthHeader;
        public request: SelfContact.TFetchAdditionalSelfContactInfoRequest;
        constructor(args: IFetchAdditionalSelfContactInfoArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchAdditionalSelfContactInfoArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchAdditionalSelfContactInfoArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_25: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_25;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_26: SelfContact.TFetchAdditionalSelfContactInfoRequest = SelfContact.TFetchAdditionalSelfContactInfoRequest.read(input);
                            _args.request = value_26;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new FetchAdditionalSelfContactInfoArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read FetchAdditionalSelfContactInfoArgs from input");
            }
        }
    }
    export interface IFetchOriginalContactsArgsArgs {
        header: PHeader.TAuthHeader;
        request: FetchOriginalContacts.TFetchOriginalContactsRequest;
    }
    export class FetchOriginalContactsArgs {
        public header: PHeader.TAuthHeader;
        public request: FetchOriginalContacts.TFetchOriginalContactsRequest;
        constructor(args: IFetchOriginalContactsArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchOriginalContactsArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchOriginalContactsArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_27: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_27;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_28: FetchOriginalContacts.TFetchOriginalContactsRequest = FetchOriginalContacts.TFetchOriginalContactsRequest.read(input);
                            _args.request = value_28;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new FetchOriginalContactsArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read FetchOriginalContactsArgs from input");
            }
        }
    }
    export interface IGetContactsSinceBackupArgsArgs {
        header: PHeader.TAuthHeader;
        request: ContactsSinceBackup.TContactsSinceBackupRequest;
    }
    export class GetContactsSinceBackupArgs {
        public header: PHeader.TAuthHeader;
        public request: ContactsSinceBackup.TContactsSinceBackupRequest;
        constructor(args: IGetContactsSinceBackupArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("GetContactsSinceBackupArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): GetContactsSinceBackupArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_29: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_29;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_30: ContactsSinceBackup.TContactsSinceBackupRequest = ContactsSinceBackup.TContactsSinceBackupRequest.read(input);
                            _args.request = value_30;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new GetContactsSinceBackupArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read GetContactsSinceBackupArgs from input");
            }
        }
    }
    export interface IPushContactsResultArgs {
        success?: PushContacts.TPushContactsResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
        suspiciousDeviceError?: GenericExceptions.TSuspiciousDevice;
        blacklistedDeviceError?: GenericExceptions.TBlacklistedDevice;
    }
    export class PushContactsResult {
        public success?: PushContacts.TPushContactsResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        public suspiciousDeviceError?: GenericExceptions.TSuspiciousDevice;
        public blacklistedDeviceError?: GenericExceptions.TBlacklistedDevice;
        constructor(args?: IPushContactsResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
            if (args != null && args.suspiciousDeviceError != null) {
                this.suspiciousDeviceError = args.suspiciousDeviceError;
            }
            if (args != null && args.blacklistedDeviceError != null) {
                this.blacklistedDeviceError = args.blacklistedDeviceError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("PushContactsResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            if (this.suspiciousDeviceError != null) {
                output.writeFieldBegin("suspiciousDeviceError", thrift.Thrift.Type.STRUCT, 3);
                this.suspiciousDeviceError.write(output);
                output.writeFieldEnd();
            }
            if (this.blacklistedDeviceError != null) {
                output.writeFieldBegin("blacklistedDeviceError", thrift.Thrift.Type.STRUCT, 4);
                this.blacklistedDeviceError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): PushContactsResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_31: PushContacts.TPushContactsResponse = PushContacts.TPushContactsResponse.read(input);
                            _args.success = value_31;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_32: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_32;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_33: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_33;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 3:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_34: GenericExceptions.TSuspiciousDevice = GenericExceptions.TSuspiciousDevice.read(input);
                            _args.suspiciousDeviceError = value_34;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 4:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_35: GenericExceptions.TBlacklistedDevice = GenericExceptions.TBlacklistedDevice.read(input);
                            _args.blacklistedDeviceError = value_35;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new PushContactsResult(_args);
        }
    }
    export interface IFetchContactsResultArgs {
        success?: FetchContacts.TFetchContactsResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
        suspiciousDeviceError?: GenericExceptions.TSuspiciousDevice;
        blacklistedDeviceError?: GenericExceptions.TBlacklistedDevice;
    }
    export class FetchContactsResult {
        public success?: FetchContacts.TFetchContactsResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        public suspiciousDeviceError?: GenericExceptions.TSuspiciousDevice;
        public blacklistedDeviceError?: GenericExceptions.TBlacklistedDevice;
        constructor(args?: IFetchContactsResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
            if (args != null && args.suspiciousDeviceError != null) {
                this.suspiciousDeviceError = args.suspiciousDeviceError;
            }
            if (args != null && args.blacklistedDeviceError != null) {
                this.blacklistedDeviceError = args.blacklistedDeviceError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchContactsResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            if (this.suspiciousDeviceError != null) {
                output.writeFieldBegin("suspiciousDeviceError", thrift.Thrift.Type.STRUCT, 3);
                this.suspiciousDeviceError.write(output);
                output.writeFieldEnd();
            }
            if (this.blacklistedDeviceError != null) {
                output.writeFieldBegin("blacklistedDeviceError", thrift.Thrift.Type.STRUCT, 4);
                this.blacklistedDeviceError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchContactsResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_36: FetchContacts.TFetchContactsResponse = FetchContacts.TFetchContactsResponse.read(input);
                            _args.success = value_36;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_37: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_37;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_38: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_38;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 3:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_39: GenericExceptions.TSuspiciousDevice = GenericExceptions.TSuspiciousDevice.read(input);
                            _args.suspiciousDeviceError = value_39;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 4:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_40: GenericExceptions.TBlacklistedDevice = GenericExceptions.TBlacklistedDevice.read(input);
                            _args.blacklistedDeviceError = value_40;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new FetchContactsResult(_args);
        }
    }
    export interface IFixThisCardResultArgs {
        success?: FixThisCard.TFixThisCardResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class FixThisCardResult {
        public success?: FixThisCard.TFixThisCardResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IFixThisCardResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FixThisCardResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FixThisCardResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_41: FixThisCard.TFixThisCardResponse = FixThisCard.TFixThisCardResponse.read(input);
                            _args.success = value_41;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_42: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_42;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_43: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_43;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new FixThisCardResult(_args);
        }
    }
    export interface IGetContactDetailsResultArgs {
        success?: ContactDetails.TGetContactDetailsResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class GetContactDetailsResult {
        public success?: ContactDetails.TGetContactDetailsResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IGetContactDetailsResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("GetContactDetailsResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): GetContactDetailsResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_44: ContactDetails.TGetContactDetailsResponse = ContactDetails.TGetContactDetailsResponse.read(input);
                            _args.success = value_44;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_45: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_45;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_46: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_46;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new GetContactDetailsResult(_args);
        }
    }
    export interface IGetAnatomyOfContactResultArgs {
        success?: ContactDetails.TGetAnatomyOfContactResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class GetAnatomyOfContactResult {
        public success?: ContactDetails.TGetAnatomyOfContactResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IGetAnatomyOfContactResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("GetAnatomyOfContactResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): GetAnatomyOfContactResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_47: ContactDetails.TGetAnatomyOfContactResponse = ContactDetails.TGetAnatomyOfContactResponse.read(input);
                            _args.success = value_47;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_48: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_48;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_49: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_49;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new GetAnatomyOfContactResult(_args);
        }
    }
    export interface IGetUndoableActionsForContactResultArgs {
        success?: ContactDetails.TGetUndoableActionsForContactResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class GetUndoableActionsForContactResult {
        public success?: ContactDetails.TGetUndoableActionsForContactResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IGetUndoableActionsForContactResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("GetUndoableActionsForContactResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): GetUndoableActionsForContactResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_50: ContactDetails.TGetUndoableActionsForContactResponse = ContactDetails.TGetUndoableActionsForContactResponse.read(input);
                            _args.success = value_50;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_51: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_51;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_52: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_52;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new GetUndoableActionsForContactResult(_args);
        }
    }
    export interface IUpdateSuggestedMergesResultArgs {
        success?: SuggestMerges.TUpdateSuggestedMergeResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class UpdateSuggestedMergesResult {
        public success?: SuggestMerges.TUpdateSuggestedMergeResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IUpdateSuggestedMergesResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UpdateSuggestedMergesResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UpdateSuggestedMergesResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_53: SuggestMerges.TUpdateSuggestedMergeResponse = SuggestMerges.TUpdateSuggestedMergeResponse.read(input);
                            _args.success = value_53;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_54: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_54;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_55: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_55;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new UpdateSuggestedMergesResult(_args);
        }
    }
    export interface IUpdateMultipleSuggestedMergesResultArgs {
        success?: SuggestMerges.TUpdateSuggestedMergesResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class UpdateMultipleSuggestedMergesResult {
        public success?: SuggestMerges.TUpdateSuggestedMergesResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IUpdateMultipleSuggestedMergesResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UpdateMultipleSuggestedMergesResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UpdateMultipleSuggestedMergesResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_56: SuggestMerges.TUpdateSuggestedMergesResponse = SuggestMerges.TUpdateSuggestedMergesResponse.read(input);
                            _args.success = value_56;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_57: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_57;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_58: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_58;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new UpdateMultipleSuggestedMergesResult(_args);
        }
    }
    export interface IUndoSuggestedMergesResultArgs {
        success?: SuggestMerges.TUndoSuggestedMergeResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class UndoSuggestedMergesResult {
        public success?: SuggestMerges.TUndoSuggestedMergeResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IUndoSuggestedMergesResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UndoSuggestedMergesResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UndoSuggestedMergesResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_59: SuggestMerges.TUndoSuggestedMergeResponse = SuggestMerges.TUndoSuggestedMergeResponse.read(input);
                            _args.success = value_59;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_60: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_60;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_61: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_61;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new UndoSuggestedMergesResult(_args);
        }
    }
    export interface IExecuteManualMergeResultArgs {
        success?: SuggestMerges.TUpdateSuggestedMergeResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class ExecuteManualMergeResult {
        public success?: SuggestMerges.TUpdateSuggestedMergeResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IExecuteManualMergeResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("ExecuteManualMergeResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): ExecuteManualMergeResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_62: SuggestMerges.TUpdateSuggestedMergeResponse = SuggestMerges.TUpdateSuggestedMergeResponse.read(input);
                            _args.success = value_62;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_63: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_63;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_64: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_64;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new ExecuteManualMergeResult(_args);
        }
    }
    export interface IExecuteUndoMergeResultArgs {
        success?: UndoMerge.TUndoMergeResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class ExecuteUndoMergeResult {
        public success?: UndoMerge.TUndoMergeResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IExecuteUndoMergeResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("ExecuteUndoMergeResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): ExecuteUndoMergeResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_65: UndoMerge.TUndoMergeResponse = UndoMerge.TUndoMergeResponse.read(input);
                            _args.success = value_65;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_66: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_66;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_67: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_67;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new ExecuteUndoMergeResult(_args);
        }
    }
    export interface IEnsureSyncedResultArgs {
        success?: EnsureSynced.TEnsureSyncedResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class EnsureSyncedResult {
        public success?: EnsureSynced.TEnsureSyncedResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IEnsureSyncedResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("EnsureSyncedResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): EnsureSyncedResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_68: EnsureSynced.TEnsureSyncedResponse = EnsureSynced.TEnsureSyncedResponse.read(input);
                            _args.success = value_68;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_69: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_69;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_70: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_70;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new EnsureSyncedResult(_args);
        }
    }
    export interface IFetchAdditionalSelfContactInfoResultArgs {
        success?: SelfContact.TFetchAdditionalSelfContactInfoResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class FetchAdditionalSelfContactInfoResult {
        public success?: SelfContact.TFetchAdditionalSelfContactInfoResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IFetchAdditionalSelfContactInfoResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchAdditionalSelfContactInfoResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchAdditionalSelfContactInfoResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_71: SelfContact.TFetchAdditionalSelfContactInfoResponse = SelfContact.TFetchAdditionalSelfContactInfoResponse.read(input);
                            _args.success = value_71;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_72: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_72;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_73: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_73;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new FetchAdditionalSelfContactInfoResult(_args);
        }
    }
    export interface IFetchOriginalContactsResultArgs {
        success?: FetchOriginalContacts.TFetchOriginalContactsResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
        suspiciousDeviceError?: GenericExceptions.TSuspiciousDevice;
        blacklistedDeviceError?: GenericExceptions.TBlacklistedDevice;
    }
    export class FetchOriginalContactsResult {
        public success?: FetchOriginalContacts.TFetchOriginalContactsResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        public suspiciousDeviceError?: GenericExceptions.TSuspiciousDevice;
        public blacklistedDeviceError?: GenericExceptions.TBlacklistedDevice;
        constructor(args?: IFetchOriginalContactsResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
            if (args != null && args.suspiciousDeviceError != null) {
                this.suspiciousDeviceError = args.suspiciousDeviceError;
            }
            if (args != null && args.blacklistedDeviceError != null) {
                this.blacklistedDeviceError = args.blacklistedDeviceError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchOriginalContactsResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            if (this.suspiciousDeviceError != null) {
                output.writeFieldBegin("suspiciousDeviceError", thrift.Thrift.Type.STRUCT, 3);
                this.suspiciousDeviceError.write(output);
                output.writeFieldEnd();
            }
            if (this.blacklistedDeviceError != null) {
                output.writeFieldBegin("blacklistedDeviceError", thrift.Thrift.Type.STRUCT, 4);
                this.blacklistedDeviceError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchOriginalContactsResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_74: FetchOriginalContacts.TFetchOriginalContactsResponse = FetchOriginalContacts.TFetchOriginalContactsResponse.read(input);
                            _args.success = value_74;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_75: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_75;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_76: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_76;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 3:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_77: GenericExceptions.TSuspiciousDevice = GenericExceptions.TSuspiciousDevice.read(input);
                            _args.suspiciousDeviceError = value_77;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 4:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_78: GenericExceptions.TBlacklistedDevice = GenericExceptions.TBlacklistedDevice.read(input);
                            _args.blacklistedDeviceError = value_78;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new FetchOriginalContactsResult(_args);
        }
    }
    export interface IGetContactsSinceBackupResultArgs {
        success?: ContactsSinceBackup.TContactsSinceBackupResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class GetContactsSinceBackupResult {
        public success?: ContactsSinceBackup.TContactsSinceBackupResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IGetContactsSinceBackupResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("GetContactsSinceBackupResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): GetContactsSinceBackupResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_79: ContactsSinceBackup.TContactsSinceBackupResponse = ContactsSinceBackup.TContactsSinceBackupResponse.read(input);
                            _args.success = value_79;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_80: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_80;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_81: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_81;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new GetContactsSinceBackupResult(_args);
        }
    }
    export class Client {
        public _seqid: number;
        public _reqs: {
            [name: number]: (err: Error | object | undefined, val?: any) => void;
        };
        public output: thrift.TTransport;
        public protocol: new (trans: thrift.TTransport) => thrift.TProtocol;
        constructor(output: thrift.TTransport, protocol: new (trans: thrift.TTransport) => thrift.TProtocol) {
            this._seqid = 0;
            this._reqs = {};
            this.output = output;
            this.protocol = protocol;
        }
        public incrementSeqId(): number {
            return this._seqid += 1;
        }
        public pushContacts(header: PHeader.TAuthHeader, request: PushContacts.TPushContactsRequest): Promise<PushContacts.TPushContactsResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PushContacts.TPushContactsResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_pushContacts(header, request, requestId);
            });
        }
        public fetchContacts(header: PHeader.TAuthHeader, request: FetchContacts.TFetchContactsRequest): Promise<FetchContacts.TFetchContactsResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<FetchContacts.TFetchContactsResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_fetchContacts(header, request, requestId);
            });
        }
        public fixThisCard(header: PHeader.TAuthHeader, request: FixThisCard.TFixThisCardRequest): Promise<FixThisCard.TFixThisCardResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<FixThisCard.TFixThisCardResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_fixThisCard(header, request, requestId);
            });
        }
        public getContactDetails(header: PHeader.TAuthHeader, request: ContactDetails.TGetContactDetailsRequest): Promise<ContactDetails.TGetContactDetailsResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<ContactDetails.TGetContactDetailsResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_getContactDetails(header, request, requestId);
            });
        }
        public getAnatomyOfContact(header: PHeader.TAuthHeader, request: ContactDetails.TGetAnatomyOfContactRequest): Promise<ContactDetails.TGetAnatomyOfContactResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<ContactDetails.TGetAnatomyOfContactResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_getAnatomyOfContact(header, request, requestId);
            });
        }
        public getUndoableActionsForContact(header: PHeader.TAuthHeader, request: ContactDetails.TGetUndoableActionsForContactRequest): Promise<ContactDetails.TGetUndoableActionsForContactResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<ContactDetails.TGetUndoableActionsForContactResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_getUndoableActionsForContact(header, request, requestId);
            });
        }
        public updateSuggestedMerges(header: PHeader.TAuthHeader, request: SuggestMerges.TUpdateSuggestedMergeRequest): Promise<SuggestMerges.TUpdateSuggestedMergeResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<SuggestMerges.TUpdateSuggestedMergeResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_updateSuggestedMerges(header, request, requestId);
            });
        }
        public updateMultipleSuggestedMerges(header: PHeader.TAuthHeader, request: SuggestMerges.TUpdateSuggestedMergesRequest): Promise<SuggestMerges.TUpdateSuggestedMergesResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<SuggestMerges.TUpdateSuggestedMergesResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_updateMultipleSuggestedMerges(header, request, requestId);
            });
        }
        public undoSuggestedMerges(header: PHeader.TAuthHeader, request: SuggestMerges.TUndoSuggestedMergeRequest): Promise<SuggestMerges.TUndoSuggestedMergeResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<SuggestMerges.TUndoSuggestedMergeResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_undoSuggestedMerges(header, request, requestId);
            });
        }
        public executeManualMerge(header: PHeader.TAuthHeader, request: SuggestMerges.TUpdateSuggestedMergeRequest): Promise<SuggestMerges.TUpdateSuggestedMergeResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<SuggestMerges.TUpdateSuggestedMergeResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_executeManualMerge(header, request, requestId);
            });
        }
        public executeUndoMerge(header: PHeader.TAuthHeader, request: UndoMerge.TUndoMergeRequest): Promise<UndoMerge.TUndoMergeResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<UndoMerge.TUndoMergeResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_executeUndoMerge(header, request, requestId);
            });
        }
        public ensureSynced(header: PHeader.TAuthHeader, request: EnsureSynced.TEnsureSyncedRequest): Promise<EnsureSynced.TEnsureSyncedResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<EnsureSynced.TEnsureSyncedResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_ensureSynced(header, request, requestId);
            });
        }
        public fetchAdditionalSelfContactInfo(header: PHeader.TAuthHeader, request: SelfContact.TFetchAdditionalSelfContactInfoRequest): Promise<SelfContact.TFetchAdditionalSelfContactInfoResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<SelfContact.TFetchAdditionalSelfContactInfoResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_fetchAdditionalSelfContactInfo(header, request, requestId);
            });
        }
        public fetchOriginalContacts(header: PHeader.TAuthHeader, request: FetchOriginalContacts.TFetchOriginalContactsRequest): Promise<FetchOriginalContacts.TFetchOriginalContactsResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<FetchOriginalContacts.TFetchOriginalContactsResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_fetchOriginalContacts(header, request, requestId);
            });
        }
        public getContactsSinceBackup(header: PHeader.TAuthHeader, request: ContactsSinceBackup.TContactsSinceBackupRequest): Promise<ContactsSinceBackup.TContactsSinceBackupResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<ContactsSinceBackup.TContactsSinceBackupResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_getContactsSinceBackup(header, request, requestId);
            });
        }
        public send_pushContacts(header: PHeader.TAuthHeader, request: PushContacts.TPushContactsRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("pushContacts", thrift.Thrift.MessageType.CALL, requestId);
            const args: PushContactsArgs = new PushContactsArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_fetchContacts(header: PHeader.TAuthHeader, request: FetchContacts.TFetchContactsRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("fetchContacts", thrift.Thrift.MessageType.CALL, requestId);
            const args: FetchContactsArgs = new FetchContactsArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_fixThisCard(header: PHeader.TAuthHeader, request: FixThisCard.TFixThisCardRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("fixThisCard", thrift.Thrift.MessageType.CALL, requestId);
            const args: FixThisCardArgs = new FixThisCardArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_getContactDetails(header: PHeader.TAuthHeader, request: ContactDetails.TGetContactDetailsRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("getContactDetails", thrift.Thrift.MessageType.CALL, requestId);
            const args: GetContactDetailsArgs = new GetContactDetailsArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_getAnatomyOfContact(header: PHeader.TAuthHeader, request: ContactDetails.TGetAnatomyOfContactRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("getAnatomyOfContact", thrift.Thrift.MessageType.CALL, requestId);
            const args: GetAnatomyOfContactArgs = new GetAnatomyOfContactArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_getUndoableActionsForContact(header: PHeader.TAuthHeader, request: ContactDetails.TGetUndoableActionsForContactRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("getUndoableActionsForContact", thrift.Thrift.MessageType.CALL, requestId);
            const args: GetUndoableActionsForContactArgs = new GetUndoableActionsForContactArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_updateSuggestedMerges(header: PHeader.TAuthHeader, request: SuggestMerges.TUpdateSuggestedMergeRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("updateSuggestedMerges", thrift.Thrift.MessageType.CALL, requestId);
            const args: UpdateSuggestedMergesArgs = new UpdateSuggestedMergesArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_updateMultipleSuggestedMerges(header: PHeader.TAuthHeader, request: SuggestMerges.TUpdateSuggestedMergesRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("updateMultipleSuggestedMerges", thrift.Thrift.MessageType.CALL, requestId);
            const args: UpdateMultipleSuggestedMergesArgs = new UpdateMultipleSuggestedMergesArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_undoSuggestedMerges(header: PHeader.TAuthHeader, request: SuggestMerges.TUndoSuggestedMergeRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("undoSuggestedMerges", thrift.Thrift.MessageType.CALL, requestId);
            const args: UndoSuggestedMergesArgs = new UndoSuggestedMergesArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_executeManualMerge(header: PHeader.TAuthHeader, request: SuggestMerges.TUpdateSuggestedMergeRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("executeManualMerge", thrift.Thrift.MessageType.CALL, requestId);
            const args: ExecuteManualMergeArgs = new ExecuteManualMergeArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_executeUndoMerge(header: PHeader.TAuthHeader, request: UndoMerge.TUndoMergeRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("executeUndoMerge", thrift.Thrift.MessageType.CALL, requestId);
            const args: ExecuteUndoMergeArgs = new ExecuteUndoMergeArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_ensureSynced(header: PHeader.TAuthHeader, request: EnsureSynced.TEnsureSyncedRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("ensureSynced", thrift.Thrift.MessageType.CALL, requestId);
            const args: EnsureSyncedArgs = new EnsureSyncedArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_fetchAdditionalSelfContactInfo(header: PHeader.TAuthHeader, request: SelfContact.TFetchAdditionalSelfContactInfoRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("fetchAdditionalSelfContactInfo", thrift.Thrift.MessageType.CALL, requestId);
            const args: FetchAdditionalSelfContactInfoArgs = new FetchAdditionalSelfContactInfoArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_fetchOriginalContacts(header: PHeader.TAuthHeader, request: FetchOriginalContacts.TFetchOriginalContactsRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("fetchOriginalContacts", thrift.Thrift.MessageType.CALL, requestId);
            const args: FetchOriginalContactsArgs = new FetchOriginalContactsArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_getContactsSinceBackup(header: PHeader.TAuthHeader, request: ContactsSinceBackup.TContactsSinceBackupRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("getContactsSinceBackup", thrift.Thrift.MessageType.CALL, requestId);
            const args: GetContactsSinceBackupArgs = new GetContactsSinceBackupArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public recv_pushContacts(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: PushContactsResult = PushContactsResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else if (result.suspiciousDeviceError != null) {
                    return callback(result.suspiciousDeviceError);
                }
                else if (result.blacklistedDeviceError != null) {
                    return callback(result.blacklistedDeviceError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "pushContacts failed: unknown result"));
                    }
                }
            }
        }
        public recv_fetchContacts(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: FetchContactsResult = FetchContactsResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else if (result.suspiciousDeviceError != null) {
                    return callback(result.suspiciousDeviceError);
                }
                else if (result.blacklistedDeviceError != null) {
                    return callback(result.blacklistedDeviceError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "fetchContacts failed: unknown result"));
                    }
                }
            }
        }
        public recv_fixThisCard(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: FixThisCardResult = FixThisCardResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "fixThisCard failed: unknown result"));
                    }
                }
            }
        }
        public recv_getContactDetails(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: GetContactDetailsResult = GetContactDetailsResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "getContactDetails failed: unknown result"));
                    }
                }
            }
        }
        public recv_getAnatomyOfContact(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: GetAnatomyOfContactResult = GetAnatomyOfContactResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "getAnatomyOfContact failed: unknown result"));
                    }
                }
            }
        }
        public recv_getUndoableActionsForContact(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: GetUndoableActionsForContactResult = GetUndoableActionsForContactResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "getUndoableActionsForContact failed: unknown result"));
                    }
                }
            }
        }
        public recv_updateSuggestedMerges(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: UpdateSuggestedMergesResult = UpdateSuggestedMergesResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "updateSuggestedMerges failed: unknown result"));
                    }
                }
            }
        }
        public recv_updateMultipleSuggestedMerges(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: UpdateMultipleSuggestedMergesResult = UpdateMultipleSuggestedMergesResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "updateMultipleSuggestedMerges failed: unknown result"));
                    }
                }
            }
        }
        public recv_undoSuggestedMerges(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: UndoSuggestedMergesResult = UndoSuggestedMergesResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "undoSuggestedMerges failed: unknown result"));
                    }
                }
            }
        }
        public recv_executeManualMerge(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: ExecuteManualMergeResult = ExecuteManualMergeResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "executeManualMerge failed: unknown result"));
                    }
                }
            }
        }
        public recv_executeUndoMerge(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: ExecuteUndoMergeResult = ExecuteUndoMergeResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "executeUndoMerge failed: unknown result"));
                    }
                }
            }
        }
        public recv_ensureSynced(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: EnsureSyncedResult = EnsureSyncedResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "ensureSynced failed: unknown result"));
                    }
                }
            }
        }
        public recv_fetchAdditionalSelfContactInfo(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: FetchAdditionalSelfContactInfoResult = FetchAdditionalSelfContactInfoResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "fetchAdditionalSelfContactInfo failed: unknown result"));
                    }
                }
            }
        }
        public recv_fetchOriginalContacts(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: FetchOriginalContactsResult = FetchOriginalContactsResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else if (result.suspiciousDeviceError != null) {
                    return callback(result.suspiciousDeviceError);
                }
                else if (result.blacklistedDeviceError != null) {
                    return callback(result.blacklistedDeviceError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "fetchOriginalContacts failed: unknown result"));
                    }
                }
            }
        }
        public recv_getContactsSinceBackup(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: GetContactsSinceBackupResult = GetContactsSinceBackupResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "getContactsSinceBackup failed: unknown result"));
                    }
                }
            }
        }
    }
    export interface IHandler {
        pushContacts(header: PHeader.TAuthHeader, request: PushContacts.TPushContactsRequest): PushContacts.TPushContactsResponse | Promise<PushContacts.TPushContactsResponse>;
        fetchContacts(header: PHeader.TAuthHeader, request: FetchContacts.TFetchContactsRequest): FetchContacts.TFetchContactsResponse | Promise<FetchContacts.TFetchContactsResponse>;
        fixThisCard(header: PHeader.TAuthHeader, request: FixThisCard.TFixThisCardRequest): FixThisCard.TFixThisCardResponse | Promise<FixThisCard.TFixThisCardResponse>;
        getContactDetails(header: PHeader.TAuthHeader, request: ContactDetails.TGetContactDetailsRequest): ContactDetails.TGetContactDetailsResponse | Promise<ContactDetails.TGetContactDetailsResponse>;
        getAnatomyOfContact(header: PHeader.TAuthHeader, request: ContactDetails.TGetAnatomyOfContactRequest): ContactDetails.TGetAnatomyOfContactResponse | Promise<ContactDetails.TGetAnatomyOfContactResponse>;
        getUndoableActionsForContact(header: PHeader.TAuthHeader, request: ContactDetails.TGetUndoableActionsForContactRequest): ContactDetails.TGetUndoableActionsForContactResponse | Promise<ContactDetails.TGetUndoableActionsForContactResponse>;
        updateSuggestedMerges(header: PHeader.TAuthHeader, request: SuggestMerges.TUpdateSuggestedMergeRequest): SuggestMerges.TUpdateSuggestedMergeResponse | Promise<SuggestMerges.TUpdateSuggestedMergeResponse>;
        updateMultipleSuggestedMerges(header: PHeader.TAuthHeader, request: SuggestMerges.TUpdateSuggestedMergesRequest): SuggestMerges.TUpdateSuggestedMergesResponse | Promise<SuggestMerges.TUpdateSuggestedMergesResponse>;
        undoSuggestedMerges(header: PHeader.TAuthHeader, request: SuggestMerges.TUndoSuggestedMergeRequest): SuggestMerges.TUndoSuggestedMergeResponse | Promise<SuggestMerges.TUndoSuggestedMergeResponse>;
        executeManualMerge(header: PHeader.TAuthHeader, request: SuggestMerges.TUpdateSuggestedMergeRequest): SuggestMerges.TUpdateSuggestedMergeResponse | Promise<SuggestMerges.TUpdateSuggestedMergeResponse>;
        executeUndoMerge(header: PHeader.TAuthHeader, request: UndoMerge.TUndoMergeRequest): UndoMerge.TUndoMergeResponse | Promise<UndoMerge.TUndoMergeResponse>;
        ensureSynced(header: PHeader.TAuthHeader, request: EnsureSynced.TEnsureSyncedRequest): EnsureSynced.TEnsureSyncedResponse | Promise<EnsureSynced.TEnsureSyncedResponse>;
        fetchAdditionalSelfContactInfo(header: PHeader.TAuthHeader, request: SelfContact.TFetchAdditionalSelfContactInfoRequest): SelfContact.TFetchAdditionalSelfContactInfoResponse | Promise<SelfContact.TFetchAdditionalSelfContactInfoResponse>;
        fetchOriginalContacts(header: PHeader.TAuthHeader, request: FetchOriginalContacts.TFetchOriginalContactsRequest): FetchOriginalContacts.TFetchOriginalContactsResponse | Promise<FetchOriginalContacts.TFetchOriginalContactsResponse>;
        getContactsSinceBackup(header: PHeader.TAuthHeader, request: ContactsSinceBackup.TContactsSinceBackupRequest): ContactsSinceBackup.TContactsSinceBackupResponse | Promise<ContactsSinceBackup.TContactsSinceBackupResponse>;
    }
    export class Processor {
        public _handler: IHandler;
        constructor(handler: IHandler) {
            this._handler = handler;
        }
        public process(input: thrift.TProtocol, output: thrift.TProtocol): void {
            const metadata: thrift.TMessage = input.readMessageBegin();
            const fname: string = metadata.fname;
            const requestId: number = metadata.rseqid;
            const methodName: string = "process_" + fname;
            switch (methodName) {
                case "process_pushContacts": {
                    this.process_pushContacts(requestId, input, output);
                    return;
                }
                case "process_fetchContacts": {
                    this.process_fetchContacts(requestId, input, output);
                    return;
                }
                case "process_fixThisCard": {
                    this.process_fixThisCard(requestId, input, output);
                    return;
                }
                case "process_getContactDetails": {
                    this.process_getContactDetails(requestId, input, output);
                    return;
                }
                case "process_getAnatomyOfContact": {
                    this.process_getAnatomyOfContact(requestId, input, output);
                    return;
                }
                case "process_getUndoableActionsForContact": {
                    this.process_getUndoableActionsForContact(requestId, input, output);
                    return;
                }
                case "process_updateSuggestedMerges": {
                    this.process_updateSuggestedMerges(requestId, input, output);
                    return;
                }
                case "process_updateMultipleSuggestedMerges": {
                    this.process_updateMultipleSuggestedMerges(requestId, input, output);
                    return;
                }
                case "process_undoSuggestedMerges": {
                    this.process_undoSuggestedMerges(requestId, input, output);
                    return;
                }
                case "process_executeManualMerge": {
                    this.process_executeManualMerge(requestId, input, output);
                    return;
                }
                case "process_executeUndoMerge": {
                    this.process_executeUndoMerge(requestId, input, output);
                    return;
                }
                case "process_ensureSynced": {
                    this.process_ensureSynced(requestId, input, output);
                    return;
                }
                case "process_fetchAdditionalSelfContactInfo": {
                    this.process_fetchAdditionalSelfContactInfo(requestId, input, output);
                    return;
                }
                case "process_fetchOriginalContacts": {
                    this.process_fetchOriginalContacts(requestId, input, output);
                    return;
                }
                case "process_getContactsSinceBackup": {
                    this.process_getContactsSinceBackup(requestId, input, output);
                    return;
                }
                default: {
                    input.skip(thrift.Thrift.Type.STRUCT);
                    input.readMessageEnd();
                    const errMessage = "Unknown function " + fname;
                    const err = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN_METHOD, errMessage);
                    output.writeMessageBegin(fname, thrift.Thrift.MessageType.EXCEPTION, requestId);
                    err.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            }
        }
        public process_pushContacts(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PushContacts.TPushContactsResponse>((resolve, reject): void => {
                try {
                    const args: PushContactsArgs = PushContactsArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.pushContacts(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PushContacts.TPushContactsResponse): void => {
                const result: PushContactsResult = new PushContactsResult({ success: data });
                output.writeMessageBegin("pushContacts", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: PushContactsResult = new PushContactsResult({ authFailedError: err });
                    output.writeMessageBegin("pushContacts", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: PushContactsResult = new PushContactsResult({ invalidRequestError: err });
                    output.writeMessageBegin("pushContacts", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TSuspiciousDevice) {
                    const result: PushContactsResult = new PushContactsResult({ suspiciousDeviceError: err });
                    output.writeMessageBegin("pushContacts", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TBlacklistedDevice) {
                    const result: PushContactsResult = new PushContactsResult({ blacklistedDeviceError: err });
                    output.writeMessageBegin("pushContacts", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("pushContacts", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_fetchContacts(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<FetchContacts.TFetchContactsResponse>((resolve, reject): void => {
                try {
                    const args: FetchContactsArgs = FetchContactsArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.fetchContacts(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: FetchContacts.TFetchContactsResponse): void => {
                const result: FetchContactsResult = new FetchContactsResult({ success: data });
                output.writeMessageBegin("fetchContacts", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: FetchContactsResult = new FetchContactsResult({ authFailedError: err });
                    output.writeMessageBegin("fetchContacts", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: FetchContactsResult = new FetchContactsResult({ invalidRequestError: err });
                    output.writeMessageBegin("fetchContacts", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TSuspiciousDevice) {
                    const result: FetchContactsResult = new FetchContactsResult({ suspiciousDeviceError: err });
                    output.writeMessageBegin("fetchContacts", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TBlacklistedDevice) {
                    const result: FetchContactsResult = new FetchContactsResult({ blacklistedDeviceError: err });
                    output.writeMessageBegin("fetchContacts", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("fetchContacts", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_fixThisCard(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<FixThisCard.TFixThisCardResponse>((resolve, reject): void => {
                try {
                    const args: FixThisCardArgs = FixThisCardArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.fixThisCard(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: FixThisCard.TFixThisCardResponse): void => {
                const result: FixThisCardResult = new FixThisCardResult({ success: data });
                output.writeMessageBegin("fixThisCard", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: FixThisCardResult = new FixThisCardResult({ authFailedError: err });
                    output.writeMessageBegin("fixThisCard", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: FixThisCardResult = new FixThisCardResult({ invalidRequestError: err });
                    output.writeMessageBegin("fixThisCard", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("fixThisCard", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_getContactDetails(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<ContactDetails.TGetContactDetailsResponse>((resolve, reject): void => {
                try {
                    const args: GetContactDetailsArgs = GetContactDetailsArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.getContactDetails(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: ContactDetails.TGetContactDetailsResponse): void => {
                const result: GetContactDetailsResult = new GetContactDetailsResult({ success: data });
                output.writeMessageBegin("getContactDetails", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: GetContactDetailsResult = new GetContactDetailsResult({ authFailedError: err });
                    output.writeMessageBegin("getContactDetails", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: GetContactDetailsResult = new GetContactDetailsResult({ invalidRequestError: err });
                    output.writeMessageBegin("getContactDetails", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("getContactDetails", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_getAnatomyOfContact(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<ContactDetails.TGetAnatomyOfContactResponse>((resolve, reject): void => {
                try {
                    const args: GetAnatomyOfContactArgs = GetAnatomyOfContactArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.getAnatomyOfContact(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: ContactDetails.TGetAnatomyOfContactResponse): void => {
                const result: GetAnatomyOfContactResult = new GetAnatomyOfContactResult({ success: data });
                output.writeMessageBegin("getAnatomyOfContact", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: GetAnatomyOfContactResult = new GetAnatomyOfContactResult({ authFailedError: err });
                    output.writeMessageBegin("getAnatomyOfContact", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: GetAnatomyOfContactResult = new GetAnatomyOfContactResult({ invalidRequestError: err });
                    output.writeMessageBegin("getAnatomyOfContact", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("getAnatomyOfContact", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_getUndoableActionsForContact(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<ContactDetails.TGetUndoableActionsForContactResponse>((resolve, reject): void => {
                try {
                    const args: GetUndoableActionsForContactArgs = GetUndoableActionsForContactArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.getUndoableActionsForContact(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: ContactDetails.TGetUndoableActionsForContactResponse): void => {
                const result: GetUndoableActionsForContactResult = new GetUndoableActionsForContactResult({ success: data });
                output.writeMessageBegin("getUndoableActionsForContact", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: GetUndoableActionsForContactResult = new GetUndoableActionsForContactResult({ authFailedError: err });
                    output.writeMessageBegin("getUndoableActionsForContact", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: GetUndoableActionsForContactResult = new GetUndoableActionsForContactResult({ invalidRequestError: err });
                    output.writeMessageBegin("getUndoableActionsForContact", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("getUndoableActionsForContact", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_updateSuggestedMerges(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<SuggestMerges.TUpdateSuggestedMergeResponse>((resolve, reject): void => {
                try {
                    const args: UpdateSuggestedMergesArgs = UpdateSuggestedMergesArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.updateSuggestedMerges(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: SuggestMerges.TUpdateSuggestedMergeResponse): void => {
                const result: UpdateSuggestedMergesResult = new UpdateSuggestedMergesResult({ success: data });
                output.writeMessageBegin("updateSuggestedMerges", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: UpdateSuggestedMergesResult = new UpdateSuggestedMergesResult({ authFailedError: err });
                    output.writeMessageBegin("updateSuggestedMerges", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: UpdateSuggestedMergesResult = new UpdateSuggestedMergesResult({ invalidRequestError: err });
                    output.writeMessageBegin("updateSuggestedMerges", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("updateSuggestedMerges", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_updateMultipleSuggestedMerges(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<SuggestMerges.TUpdateSuggestedMergesResponse>((resolve, reject): void => {
                try {
                    const args: UpdateMultipleSuggestedMergesArgs = UpdateMultipleSuggestedMergesArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.updateMultipleSuggestedMerges(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: SuggestMerges.TUpdateSuggestedMergesResponse): void => {
                const result: UpdateMultipleSuggestedMergesResult = new UpdateMultipleSuggestedMergesResult({ success: data });
                output.writeMessageBegin("updateMultipleSuggestedMerges", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: UpdateMultipleSuggestedMergesResult = new UpdateMultipleSuggestedMergesResult({ authFailedError: err });
                    output.writeMessageBegin("updateMultipleSuggestedMerges", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: UpdateMultipleSuggestedMergesResult = new UpdateMultipleSuggestedMergesResult({ invalidRequestError: err });
                    output.writeMessageBegin("updateMultipleSuggestedMerges", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("updateMultipleSuggestedMerges", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_undoSuggestedMerges(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<SuggestMerges.TUndoSuggestedMergeResponse>((resolve, reject): void => {
                try {
                    const args: UndoSuggestedMergesArgs = UndoSuggestedMergesArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.undoSuggestedMerges(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: SuggestMerges.TUndoSuggestedMergeResponse): void => {
                const result: UndoSuggestedMergesResult = new UndoSuggestedMergesResult({ success: data });
                output.writeMessageBegin("undoSuggestedMerges", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: UndoSuggestedMergesResult = new UndoSuggestedMergesResult({ authFailedError: err });
                    output.writeMessageBegin("undoSuggestedMerges", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: UndoSuggestedMergesResult = new UndoSuggestedMergesResult({ invalidRequestError: err });
                    output.writeMessageBegin("undoSuggestedMerges", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("undoSuggestedMerges", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_executeManualMerge(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<SuggestMerges.TUpdateSuggestedMergeResponse>((resolve, reject): void => {
                try {
                    const args: ExecuteManualMergeArgs = ExecuteManualMergeArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.executeManualMerge(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: SuggestMerges.TUpdateSuggestedMergeResponse): void => {
                const result: ExecuteManualMergeResult = new ExecuteManualMergeResult({ success: data });
                output.writeMessageBegin("executeManualMerge", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: ExecuteManualMergeResult = new ExecuteManualMergeResult({ authFailedError: err });
                    output.writeMessageBegin("executeManualMerge", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: ExecuteManualMergeResult = new ExecuteManualMergeResult({ invalidRequestError: err });
                    output.writeMessageBegin("executeManualMerge", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("executeManualMerge", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_executeUndoMerge(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<UndoMerge.TUndoMergeResponse>((resolve, reject): void => {
                try {
                    const args: ExecuteUndoMergeArgs = ExecuteUndoMergeArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.executeUndoMerge(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: UndoMerge.TUndoMergeResponse): void => {
                const result: ExecuteUndoMergeResult = new ExecuteUndoMergeResult({ success: data });
                output.writeMessageBegin("executeUndoMerge", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: ExecuteUndoMergeResult = new ExecuteUndoMergeResult({ authFailedError: err });
                    output.writeMessageBegin("executeUndoMerge", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: ExecuteUndoMergeResult = new ExecuteUndoMergeResult({ invalidRequestError: err });
                    output.writeMessageBegin("executeUndoMerge", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("executeUndoMerge", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_ensureSynced(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<EnsureSynced.TEnsureSyncedResponse>((resolve, reject): void => {
                try {
                    const args: EnsureSyncedArgs = EnsureSyncedArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.ensureSynced(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: EnsureSynced.TEnsureSyncedResponse): void => {
                const result: EnsureSyncedResult = new EnsureSyncedResult({ success: data });
                output.writeMessageBegin("ensureSynced", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: EnsureSyncedResult = new EnsureSyncedResult({ authFailedError: err });
                    output.writeMessageBegin("ensureSynced", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: EnsureSyncedResult = new EnsureSyncedResult({ invalidRequestError: err });
                    output.writeMessageBegin("ensureSynced", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("ensureSynced", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_fetchAdditionalSelfContactInfo(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<SelfContact.TFetchAdditionalSelfContactInfoResponse>((resolve, reject): void => {
                try {
                    const args: FetchAdditionalSelfContactInfoArgs = FetchAdditionalSelfContactInfoArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.fetchAdditionalSelfContactInfo(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: SelfContact.TFetchAdditionalSelfContactInfoResponse): void => {
                const result: FetchAdditionalSelfContactInfoResult = new FetchAdditionalSelfContactInfoResult({ success: data });
                output.writeMessageBegin("fetchAdditionalSelfContactInfo", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: FetchAdditionalSelfContactInfoResult = new FetchAdditionalSelfContactInfoResult({ authFailedError: err });
                    output.writeMessageBegin("fetchAdditionalSelfContactInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: FetchAdditionalSelfContactInfoResult = new FetchAdditionalSelfContactInfoResult({ invalidRequestError: err });
                    output.writeMessageBegin("fetchAdditionalSelfContactInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("fetchAdditionalSelfContactInfo", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_fetchOriginalContacts(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<FetchOriginalContacts.TFetchOriginalContactsResponse>((resolve, reject): void => {
                try {
                    const args: FetchOriginalContactsArgs = FetchOriginalContactsArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.fetchOriginalContacts(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: FetchOriginalContacts.TFetchOriginalContactsResponse): void => {
                const result: FetchOriginalContactsResult = new FetchOriginalContactsResult({ success: data });
                output.writeMessageBegin("fetchOriginalContacts", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: FetchOriginalContactsResult = new FetchOriginalContactsResult({ authFailedError: err });
                    output.writeMessageBegin("fetchOriginalContacts", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: FetchOriginalContactsResult = new FetchOriginalContactsResult({ invalidRequestError: err });
                    output.writeMessageBegin("fetchOriginalContacts", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TSuspiciousDevice) {
                    const result: FetchOriginalContactsResult = new FetchOriginalContactsResult({ suspiciousDeviceError: err });
                    output.writeMessageBegin("fetchOriginalContacts", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TBlacklistedDevice) {
                    const result: FetchOriginalContactsResult = new FetchOriginalContactsResult({ blacklistedDeviceError: err });
                    output.writeMessageBegin("fetchOriginalContacts", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("fetchOriginalContacts", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_getContactsSinceBackup(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<ContactsSinceBackup.TContactsSinceBackupResponse>((resolve, reject): void => {
                try {
                    const args: GetContactsSinceBackupArgs = GetContactsSinceBackupArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.getContactsSinceBackup(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: ContactsSinceBackup.TContactsSinceBackupResponse): void => {
                const result: GetContactsSinceBackupResult = new GetContactsSinceBackupResult({ success: data });
                output.writeMessageBegin("getContactsSinceBackup", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: GetContactsSinceBackupResult = new GetContactsSinceBackupResult({ authFailedError: err });
                    output.writeMessageBegin("getContactsSinceBackup", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: GetContactsSinceBackupResult = new GetContactsSinceBackupResult({ invalidRequestError: err });
                    output.writeMessageBegin("getContactsSinceBackup", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("getContactsSinceBackup", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
    }
}
